function openFirstListItem(selector) {
    const itemEl = $(selector)[0]
    if (itemEl) {
        $(itemEl).find('.js-item-content').removeClass('hidden')
        $(itemEl).find('.js-item-icon').addClass('active')
    }
}

function toggleListItem() {
    const itemsEl = $('.js-item-element')
    itemsEl.on('click', function () {
        const target = $(this)
        const parentEl = target.closest('.js-item')
        const contentEl = parentEl.find('.js-item-content').get(0)
        const iconEl = parentEl.find('.js-item-icon')
        iconEl.toggleClass('active')
        $(contentEl).slideToggle(200)
    })
}

window.addEventListener('load', function () {
    openFirstListItem('.service-landing .js-item')
    toggleListItem()
})
